import userConnectionLists, { type UserConnectionListsState } from '@alltrails/redux/slices/userConnectionLists';
import userConnections from '@alltrails/redux/slices/userConnections';
import type Context from '@alltrails/core/types/Context';
import context from '@alltrails/context/slices/contextSlice';
import type { AlgoliaConfigs } from '@alltrails/types/algoliaConfigs';
import algoliaConfigs from '@alltrails/redux/slices/algoliaConfigs';
import facebook, { type FacebookState } from '@alltrails/redux/slices/facebook';
import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

type State = {
  facebook: FacebookState;
  context: Context;
  userConnectionLists: UserConnectionListsState;
  algoliaConfigs: AlgoliaConfigs;
};

export const reducer = {
  facebook,
  context,
  userConnections,
  userConnectionLists,
  algoliaConfigs
};

export const buildStore = (preloadedState?: State) => configureStore({ reducer, preloadedState });

export type AppStore = ReturnType<typeof buildStore>;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<AppStore['getState']>;

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = (selector: (state: RootState) => any, equalityFn = shallowEqual) =>
  useSelector<RootState, any>(selector, equalityFn);
